import './letters.css';

const letters = [
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
];

export default function Letters({handleLetterClick}) {
  return (
    <div className="letters">
      {letters.map((letter, index) => <div className="letter" key={index} onClick={(e) => handleLetterClick(e)}>{letter}</div>)}
    </div>
  )
}
